import { CREATE_QUIZ_QUESTION, RESET_QUIZ_CREATION, CREATE_QUIZ_ERROR_REMOVE, CREATE_QUIZ_ERROR_SET } from "./actionTypes";
import axios from '../../axios/axios-quiz';

export const createQuizQuestion = (item) => ({ type: CREATE_QUIZ_QUESTION, item })

export const createQuizErrorSet = () => ({ type: CREATE_QUIZ_ERROR_SET })

export const createQuizErrorRemove = () => ({ type: CREATE_QUIZ_ERROR_REMOVE })

export const resetQuizCreation = () => ({ type: RESET_QUIZ_CREATION })

export const finishCreateQuiz = () => async (dispatch, getState) => {
  try {
    await axios.post('/quizes.json', getState().create.quiz)
    dispatch(resetQuizCreation())
  }
  catch{
    dispatch(createQuizErrorSet)
  }
}